import * as angular from "angular";
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {DeliveriesRequestsService} from "../../services/deliveries-requests.service";
import {ServicesViewsStateType} from "../../types/services-views-state.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {PlanningRouteOverviewSettingsModel} from "../../../planning/models/planning-route-overview-settings.model";

export class ServicesPanelComponent implements IController {

  from: number;
  to: number;
  selectedServices: any[];
  onSelectedServicesChange: Function;

  public selectedServiceIds: string[];
  public servicesRef: any;
  public infiniteScroll: any;

  public loadLimit: number = 20;
  public queryString: string;
  public branchIds: string[];
  public serviceAreaIds: string[];
  public group: string;
  public inRoute: boolean = false;
  public totals: any;
  public totalsLoading: boolean = false;
  public serviceSettings: any;

  /* @ngInject */
  constructor(private deliveriesConstants, private deliveriesRequestsService: DeliveriesRequestsService, private splitService: SplitService,
              private $deliveries, private $infiniteScroll, private $log: ILogService, private commonsConstants) {
    this.servicesRef = this.$deliveries();
  }

  $onInit() {
    this.servicesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.servicesRef, this.loadLimit);
    this.serviceSettings = this.splitService.getSiteDeliverySettings();

    this.selectedServiceIds = this.selectedServices?.length ?
      _.map(this.selectedServices, 'id') : [];

  };

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.selectedServices && !changes.selectedServices.isFirstChange()) {
      this.selectedServiceIds = _.map(this.selectedServices, 'id');
    }
    if ((changes.from && !changes.from.isFirstChange()) || (changes.to && !changes.to.isFirstChange())) {
      this._reloadServices();
      this._getTotals();
    }
  }

  onBranchesChange(branchIds) {
    this.branchIds = branchIds;
    this._reloadServices();
    this._getTotals();
  }

  onChangeServiceAreas(serviceAreaIds) {
    this.serviceAreaIds = serviceAreaIds;
    this._reloadServices();
    this._getTotals();
  }

  changeGroup(group) {
    this.group = group;
    this._reloadServices();
    this._getTotals();
  }

  onChangeInRoute(inRoute) {
    this.inRoute = inRoute;
    this._reloadServices();
    this._getTotals();
  }

  onQueryChange(queryString) {
    this.queryString = queryString;
    this._reloadServices();
  }

  onViewSettingsChange(settings: any) {
    this.serviceSettings = settings;
  }

  private _getTotals() {

    this.totalsLoading = true;
    this.deliveriesRequestsService.getTotals(
      this.from,
      this.to,
      undefined,
      this.branchIds,
      undefined,
      undefined,
      undefined,
      undefined,
      this.serviceAreaIds,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      this.inRoute
    )
      .then((totals) => {
        const totalsCopy = {};
        _.forOwn(totals, (value, key) => {

          if (key === 'unAssigned') {
            totalsCopy['Unassigned'] = value;
            return;
          }

          const string = _.camelCase(key);
          totalsCopy[string.charAt(0).toUpperCase() + string.slice(1)] = value;
        })
        this.totals = totalsCopy;
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to get totals @deliveriesView@loadTotals', error);
        }
      })
      .finally(() => {
        this.totalsLoading = false;
      });
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      from: this.from,
      to: this.to,
      branchIds: this.branchIds,
      areaIds: this.serviceAreaIds,
      // agentIds: this.agentIds,
      group: this.group,
      inRoute: this.inRoute,
    };
  }

  private _reloadServices() {
    this.servicesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesPanel', {
    bindings: {
      from: '<',
      to: '<',
      selectedServices: '<?',
      onSelectedServicesChange: '&'
    },
    template: require('./services-panel.html').default,
    controller: ServicesPanelComponent
  });
